module.exports = __webpack_public_path__ + "img/category-new-released-hover.22a7e8b5.png";